function colorsSlider() {

    var slider = $('._js-colors-slider').not('.slick-initialized');

    if ( slider.length ) {
        slider.slick({
            slidesToShow: 6,
            slidesToScroll: 6,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev colors-slider__prev"><svg class="i _shevron-left"><use xlink:href="#shevron-left"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next colors-slider__next"><svg class="i _shevron-right"><use xlink:href="#shevron-right"/></svg></button>',
            dots: false,
            infinite: false,
            rows: 0,
            responsive: [
            ]
        });

    }
}
